import React from 'react';
import { useIntl } from 'react-intl';
import Dialog from '@/components/dialogs/Dialog';
import DataManagementDictionaryErrorTable from './DataManagementDictionaryErrorTable';
import { isInvalidFieldsError, isInvalidTableError } from '../helper';
import ValidateDataResultsNotRun from './ValidateDataResultsNotRun';
import ValidateDataResultsValid from './ValidateDataResultsValid';
import DataManagementDictionaryFieldErrorsTable from './DataManagementDictionaryFieldErrorsTable';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const ValidateDataResultsDialog = ({ theme }) => {
  const intl = useIntl();
  const {
    category, code, dictionaryCode, dictionaryName, valid, errors,
  } = Selectors.useValidateDataResultsDialog();
  const hide = Events.useHideValidateDataResultsDialog(category, { code });

  return (
    <Dialog
      className="attached aridhia-validate-dataset-results-dialog"
      onClose={() => hide(category, code, dictionaryCode)}
      size="large"
      theme={theme}
      title={intl.formatMessage({ id: 'dataset.data.dictionary.validation.results.for' }, { name: dictionaryName })}
    >
      {valid !== true && valid !== false && <ValidateDataResultsNotRun />}
      {valid === true && <ValidateDataResultsValid />}
      {valid === false && isInvalidTableError(errors) && (
        <DataManagementDictionaryErrorTable error={errors[0].message} />
      )}
      {valid === false && isInvalidFieldsError(errors) && <DataManagementDictionaryFieldErrorsTable errors={errors} />}
    </Dialog>
  );
};

export default ValidateDataResultsDialog;
